export default {
  // 获取手机验证码
  getAuthCode: '/member/anonymous/amc/getAuthCode',
  // 获取用户信息
  getMemberByToken: '/member/anonymous/amc/getMemberByToken',
  // 微信授权登录后获取登录信息
  getWeixinMemberInfo: '/member/anonymous/amc/getWeixinMemberInfo',
}